import React from "react";
import { motion } from "framer-motion";
import { blogs } from "../Blog";

const OtherBlogs = ({ currentBlogSlug = null }) => {

  // HOME PAGE
  // If no currentBlogSlug is provided, show the first 3 blogs
  let displayBlogs;

  if (currentBlogSlug) {

    // BLOG DETAIL PAGE
    // Remove current blog and take latest 3
    displayBlogs = blogs
      .filter((blog) => blog.slug !== currentBlogSlug)
      .slice(0, 3);

  } else {

    // HOME PAGE
    displayBlogs = blogs.slice(0, 3);

  }

  // If there are no other blogs, don't display section
  if (displayBlogs.length === 0) {
    return null;
  }

  return (
    <section className="other-blogs-section">
      <div className="container">

        {/* SUBHEADING */}
        <motion.p
          className="section-subheading"
          initial={{
            opacity: 0,
            y: 20,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
          }}
        >
          {currentBlogSlug
            ? "More From Our Blog"
            : "Expert Packaging Insights"}
        </motion.p>

        {/* HEADING */}
        <motion.h2
          className="section-heading"
          initial={{
            opacity: 0,
            y: 30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            delay: 0.12,
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
          }}
        >
          {currentBlogSlug
            ? "Explore More Packaging Insights"
            : "Industrial Packaging Insights & Technical Guides"}
        </motion.h2>

        {/* BLOG GRID */}
        <motion.div
          className={`other-blog-grid ${
            displayBlogs.length === 1
              ? "one-blog"
              : displayBlogs.length === 2
              ? "two-blogs"
              : ""
          }`}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.12,
          }}
        >

          {displayBlogs.map((blog, index) => (

            <motion.article
              key={blog.slug || index}
              className="products-card"
              variants={{
                hidden: {
                  opacity: 0,
                  y: 45,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
              transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
              }}
            >

              {/* IMAGE */}

              <div
                style={{
                  overflow: "hidden",
                }}
              >

                <motion.img
                  src={blog.img}
                  alt={`${blog.title} | Gurukrupa Wood Pvt. Ltd.`}
                  initial={{
                    opacity: 0,
                    scale: 1.04,
                  }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                  }}
                  transition={{
                    duration: 0.8,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  viewport={{
                    once: true,
                  }}
                />

              </div>

              {/* CONTENT */}

              <motion.div
                className="product-card"
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  delay: 0.2,
                  duration: 0.6,
                  ease: [0.22, 1, 0.36, 1],
                }}
                viewport={{
                  once: true,
                }}
              >

                {/* TITLE */}

                <h3 className="card-heading">
                  {blog.title}
                </h3>

                {/* DESCRIPTION */}

                <p className="section-text">
                  {blog.desc}
                </p>

                {/* KNOW MORE */}

                <motion.a
                  href={`/blog/${blog.slug}`}
                  className="product-card-link"
                  whileHover="hover"
                  initial="rest"
                >

                  <motion.span
                    className="know-more-text"
                    variants={{
                      rest: {
                        opacity: 0,
                        width: 0,
                        marginRight: 0,
                      },
                      hover: {
                        opacity: 1,
                        width: "auto",
                        marginRight: 4,
                      },
                    }}
                    transition={{
                      duration: 0.3,
                    }}
                  >
                    Know More
                  </motion.span>

                  <motion.span
                    className="arrow-icon"
                    variants={{
                      rest: {
                        x: 0,
                      },
                      hover: {
                        x: 8,
                      },
                    }}
                    transition={{
                      duration: 0.3,
                    }}
                  >
                    →
                  </motion.span>

                </motion.a>

              </motion.div>

            </motion.article>

          ))}

        </motion.div>

      </div>
    </section>
  );
};

export default OtherBlogs;